module.exports = __webpack_public_path__ + "img/AccountLogo.d055deb9.svg";